
import styles from "./css/appContent.module.css"

import { useEffect } from "react";
import { database } from "../services/firebase-config";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import ModalCreateUpdateSlider from "../components/Contents/ModalCreateUpdateSlider";
import ModalUpdateStoreBanner from "../components/Contents/ModalUpdateStoreBanner";
import Loading from "../components/Loading";
import ModalUpdateHomeBanner from "../components/Contents/ModalUpdateHomeBanner";

import AliceCarousel from 'react-alice-carousel';



export default function AppContent({ setHeader }) {

    const [appConfig, setAppConfig] = useState({});
    const [refreshData, setRefreshData] = useState(0);

    const handleDragStart = (e) => e.preventDefault();


    const carousselResponsive = {
        0: { items: 2 },
        568: { items: 3 },
        1024: { items: 5 },
    };

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalStoreVisible, setIsModalStoreVisible] = useState(false);
    const [isModalBannerVisible, setIsModalBannerVisible] = useState(false);

    const [modalRemoveSlide, setModalRemoveSlide] = useState(false);
    const [modalRemoveSlideData, setModalRemoveSlideData] = useState({});

    const [isRemoveSlideLoading, setIsRemoveSlideLoading] = useState(false);

    const [cardScrollSize, setCardScrollSize] = useState(220);

    const [isPageLoading, setIsPageLoading] = useState(true);

    const configCollectionRef = collection(database, 'config');
    const appDocReference = doc(configCollectionRef, 'app');

    async function getConfigDoc() {
        setIsPageLoading(true)
        const data = await getDoc(appDocReference);
        const docData = data.data()
        setAppConfig(docData);

        handlerScroll(docData);

        console.log("getFirebaseData");
        setIsPageLoading(false)
    }

    function handlerScroll(docData) {
        console.log(docData.slide.length);
        const addNumber = docData.slide.length;
        const newSize = 230 * addNumber;
        setCardScrollSize(newSize);
        console.log(cardScrollSize);
    }

    async function removeSlide() {
        setIsRemoveSlideLoading(true);
        console.log(modalRemoveSlideData.index);
        appConfig.slide.splice(modalRemoveSlideData.index, 1);
        await updateDoc(appDocReference, appConfig);
        updateFirebaseData();
        setModalRemoveSlide(false);
        setIsRemoveSlideLoading(false);
    }

    function updateFirebaseData() {
        setRefreshData(refreshData + 1);
    }

    useEffect(() => {
        setHeader(true);
    }, []);

    useEffect(() => {
        getConfigDoc();
    }, [refreshData]);

    return (

        <div className={styles.container}>
            <h1>Configurações do Aplicativo IDE</h1>

            {isPageLoading ? <Loading /> :
                <>
                    <div>
                        <div className={styles.titleButton}>
                            <h2>Carrossel de imagens</h2>
                            <button className={styles.newContentButton} onClick={() => { setIsModalVisible(true) }}>Adicionar imagem</button>
                        </div>

                        {/* <div className={styles.carouselContainer}>
                            <div className={styles.carousel} style={{ width: cardScrollSize }}>
                                {appConfig.slide && appConfig.slide.map((slide, index) => {

                                    return (
                                        <div onClick={() => { setModalRemoveSlideData({img:slide,index:index}); setModalRemoveSlide(true) }} className={styles.card}>
                                            <img key={slide} src={slide} alt="home slide" />
                                        </div>
                                    );
                                })}
                            </div>
                        </div> */}
                        <AliceCarousel
                            mouseTracking={true}
                            infinite={true}
                            responsive={carousselResponsive}
                            controlsStrategy="alternate"
                            items={appConfig.slide && appConfig.slide.map((slide, index) => {
                                return (
                                    <div onClick={() => { setModalRemoveSlideData({ img: slide, index: index }); setModalRemoveSlide(true) }} className={styles.card}>
                                        <img key={slide} src={slide} alt="home slide" />
                                    </div>
                                );
                            })} />


                        {isModalVisible && <ModalCreateUpdateSlider updateData={updateFirebaseData} docRef={appDocReference} update={false} setModalVisible={setIsModalVisible} />}
                    </div>


                    <div>
                        <div className={styles.titleButton}>
                            <h2>Imagem da loja</h2>
                            <button className={styles.newContentButton} onClick={() => { setIsModalStoreVisible(true) }}>Alterar imagem</button>
                        </div>

                        <div>
                            <div onClick={() => { }} className={styles.card}>
                                <img key={appConfig.store.url} src={appConfig.store.url} alt="home slide" />
                            </div>
                        </div>

                        {isModalStoreVisible && <ModalUpdateStoreBanner updateData={updateFirebaseData} docRef={appDocReference} update={false} setModalVisible={setIsModalStoreVisible} />}
                    </div>


                    <div>
                        <div className={styles.titleButton}>
                            <h2>Imagem da tela inicial</h2>
                            <button className={styles.newContentButton} onClick={() => { setIsModalBannerVisible(true) }}>Alterar imagem</button>
                        </div>

                        <div>
                            <div onClick={() => { }} className={styles.card}>
                                <img key={appConfig.home.url} src={appConfig.home.url} alt="home slide" />
                            </div>
                        </div>

                        {isModalBannerVisible && <ModalUpdateHomeBanner updateData={updateFirebaseData} docRef={appDocReference} update={false} setModalVisible={setIsModalBannerVisible} />}
                    </div>

                </>
            }

            {modalRemoveSlide &&
                <div className={styles.modalContainer}>
                    <div className={styles.modalCard}>
                        {isRemoveSlideLoading && <Loading />}
                        <h2 className={styles.modalCard__title}>Deletar</h2>
                        <p className={styles.modalCard__alert}>Tem certeza que deseja <strong>deletar</strong> este item?</p>
                        <div className={styles.removeImage}>
                            <img src={modalRemoveSlideData.img} alt="imagem modal" />
                        </div>
                        <div className={styles.modalCard__buttonsContainer}>
                            <button onClick={() => { setModalRemoveSlide(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                            <button onClick={() => { removeSlide() }} className={styles.modalCard__deleteButton}>Deletar</button>
                        </div>
                    </div>
                </div>
            }

        </div>
    );

}